import React from 'react';

import { ScreenReaderOnly } from '@opendoor/bricks/utils';

import { usePath } from 'shared/helpers/hooks/usePath';

/**
 * Announce internal page navigation to screen readers
 * @see https://estevanmaito.me/blog/accessible-navigation-using-react-router
 */
export const InternalNavA11yAnnouncer: React.FC = () => {
  const [a11yMessage, setA11yMessage] = React.useState('');
  const path = usePath();

  React.useEffect(() => {
    // make sure navigation has occurred and screen reader is ready
    setTimeout(() => setA11yMessage(`Navigated to the ${path} page.`), 500);
  }, [path]);

  return (
    <ScreenReaderOnly as="span" role="status" aria-live="polite" aria-atomic="true">
      {a11yMessage}
    </ScreenReaderOnly>
  );
};
